import { apiRoutes } from '@features/campaigns/performance/consts/apiRoutes.ts';
import { AISummaryType } from '@features/campaigns/performance/types/performance.ts';
import { apiClient } from '@shared/api/ApiClient.ts';
import { CampaignId } from '@shared/types/campaign.ts';

export async function getAISummary(campaignId: CampaignId): Promise<AISummaryType | null> {
  return await apiClient.get<AISummaryType | null>(apiRoutes.getAISummary(campaignId));
}
